import React from 'react';

import { IconProps } from '../DefaultIcon';

export function SGQIcon({ className }: IconProps) {
  return (
    <svg
      width="93"
      height="97"
      viewBox="0 0 93 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1234_7)">
        <path
          d="M76.1367 14.2864V96.9765H9.36211C4.19157 96.9765 -0.000778198 92.7814 -0.000778198 87.6074V14.2864C-0.000778198 12.352 1.55971 10.7905 3.49284 10.7905L72.6431 10.7905C74.5762 10.7905 76.1367 12.352 76.1367 14.2864Z"
          fill="#E8EDF8"
        />
        <path
          d="M10.5977 97.0001C15.6518 97.0001 19.8441 93.2479 20.5195 88.3536C20.636 87.5612 21.2881 86.9785 22.08 86.9785H84.4527C85.4309 86.9785 86.1762 87.8641 85.9898 88.8197C85.1281 93.4809 81.0522 97.0001 76.1611 97.0001H10.5977Z"
          fill="#00C4B3"
        />
        <path
          d="M14.9996 34.4932C14.6503 34.4932 14.3009 34.3534 14.0447 34.097L10.6908 30.7409C10.1551 30.2049 10.1551 29.3659 10.6908 28.8298C11.2265 28.2938 12.065 28.2938 12.6007 28.8298L14.9996 31.2304L20.5894 25.6369C21.1251 25.1009 21.9636 25.1009 22.4992 25.6369C23.0349 26.1729 23.0349 27.012 22.4992 27.548L15.9545 34.097C15.6983 34.3534 15.349 34.4932 14.9996 34.4932Z"
          fill="#00416B"
        />
        <path
          d="M14.9996 46.8687C14.6503 46.8687 14.3009 46.7289 14.0447 46.4725L10.6908 43.1164C10.1551 42.5804 10.1551 41.7414 10.6908 41.2053C11.2265 40.6693 12.065 40.6693 12.6007 41.2053L14.9996 43.6058L20.5894 38.0124C21.1251 37.4763 21.9636 37.4763 22.4992 38.0124C23.0349 38.5484 23.0349 39.3874 22.4992 39.9235L15.9545 46.4725C15.6983 46.7289 15.349 46.8687 14.9996 46.8687Z"
          fill="#00416B"
        />
        <path
          d="M14.9996 59.2207C14.6503 59.2207 14.3009 59.0809 14.0447 58.8245L10.6908 55.4685C10.1551 54.9324 10.1551 54.0934 10.6908 53.5574C11.2265 53.0213 12.065 53.0213 12.6007 53.5574L14.9996 55.9579L20.5894 50.3644C21.1251 49.8284 21.9636 49.8284 22.4992 50.3644C23.0349 50.9005 23.0349 51.7395 22.4992 52.2755L15.9545 58.8245C15.6983 59.0809 15.349 59.2207 14.9996 59.2207Z"
          fill="#00416B"
        />
        <path
          d="M14.9996 71.6197C14.6503 71.6197 14.3009 71.4798 14.0447 71.2235L10.6908 67.8674C10.1551 67.3314 10.1551 66.4923 10.6908 65.9563C11.2265 65.4203 12.065 65.4203 12.6007 65.9563L14.9996 68.3568L20.5894 62.7634C21.1251 62.2273 21.9636 62.2273 22.4992 62.7634C23.0349 63.2994 23.0349 64.1384 22.4992 64.6745L15.9545 71.2235C15.6983 71.4798 15.349 71.6197 14.9996 71.6197Z"
          fill="#00416B"
        />
        <path
          d="M63.1409 31.3236H29.5091C28.7638 31.3236 28.1582 30.7177 28.1582 29.9719C28.1582 29.2261 28.7638 28.6201 29.5091 28.6201H63.1409C63.8862 28.6201 64.4918 29.2261 64.4918 29.9719C64.4918 30.7177 63.8862 31.3236 63.1409 31.3236Z"
          fill="#00C4B3"
        />
        <path
          d="M52.7764 43.8153H29.4856C28.7403 43.8153 28.1348 43.2094 28.1348 42.4636C28.1348 41.7178 28.7403 41.1118 29.4856 41.1118H52.7764C53.5217 41.1118 54.1273 41.7178 54.1273 42.4636C54.1273 43.2094 53.5217 43.8153 52.7764 43.8153Z"
          fill="#00C4B3"
        />
        <path
          d="M46.0687 56.3075H29.4856C28.7403 56.3075 28.1348 55.7016 28.1348 54.9558C28.1348 54.21 28.7403 53.604 29.4856 53.604H46.0687C46.814 53.604 47.4195 54.21 47.4195 54.9558C47.4195 55.7016 46.814 56.3075 46.0687 56.3075Z"
          fill="#00C4B3"
        />
        <path
          d="M52.7764 68.8231H29.4856C28.7403 68.8231 28.1348 68.2172 28.1348 67.4714C28.1348 66.7256 28.7403 66.1196 29.4856 66.1196H52.7764C53.5217 66.1196 54.1273 66.7256 54.1273 67.4714C54.1273 68.2172 53.5217 68.8231 52.7764 68.8231Z"
          fill="#00C4B3"
        />
        <path
          d="M74.1341 37.7559C84.5532 37.7559 92.9996 29.3039 92.9996 18.8779C92.9996 8.45194 84.5532 0 74.1341 0C63.7149 0 55.2686 8.45194 55.2686 18.8779C55.2686 29.3039 63.7149 37.7559 74.1341 37.7559Z"
          fill="#00416B"
        />
        <path
          d="M87.6893 20.4394C87.6427 19.7402 87.2701 19.2275 86.8275 18.9478C86.6412 18.8313 86.6412 18.5749 86.8042 18.4584C87.2002 18.1787 87.6194 17.6427 87.6194 16.8503C87.6194 15.8248 86.8042 15.079 85.4767 14.9625C83.8696 14.8226 79.8403 15.1489 79.1882 14.4264C78.6059 13.7972 79.9568 11.9327 79.7937 10.1381C79.5841 7.78419 78.4429 6.17607 77.1153 6.12946C75.7644 6.08285 75.2753 6.59558 75.2753 6.59558C75.2753 6.59558 75.9275 10.2313 75.4849 11.6996C75.0657 13.0514 73.808 13.5874 73.0161 14.5896C71.805 16.1278 72.1311 16.9668 71.0597 17.5961C70.4541 17.9457 69.406 18.0156 68.2881 18.0156V28.2236C68.2881 28.2236 69.6855 28.4567 71.0597 28.6665C74.3903 29.1559 82.0995 28.9228 84.1957 28.6665C85.2671 28.5266 86.1055 27.6643 86.1055 26.5922C86.1055 26.3359 86.0589 26.1028 85.9658 25.8697C85.9192 25.7066 86.0124 25.5667 86.1521 25.5201C86.8974 25.3104 87.2468 24.7277 87.3632 24.0052C87.4797 23.2128 87.1303 22.7234 86.7809 22.4437C86.6645 22.3505 86.6878 22.1874 86.7809 22.1174C87.4098 21.7679 87.6893 21.1153 87.666 20.486L87.6893 20.4394Z"
          fill="white"
        />
        <path
          d="M67.2403 16.1045H62.3259C61.3612 16.1045 60.5791 16.8871 60.5791 17.8524V28.1304C60.5791 29.0958 61.3612 29.8784 62.3259 29.8784H67.2403C68.205 29.8784 68.9871 29.0958 68.9871 28.1304V17.8524C68.9871 16.8871 68.205 16.1045 67.2403 16.1045Z"
          fill="#00C4B3"
        />
        <path
          d="M66.3091 28.2704C66.8622 28.2704 67.3106 27.8218 67.3106 27.2683C67.3106 26.7148 66.8622 26.2661 66.3091 26.2661C65.756 26.2661 65.3076 26.7148 65.3076 27.2683C65.3076 27.8218 65.756 28.2704 66.3091 28.2704Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1234_7">
          <rect width="93" height="97" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
